export class Roles {
    ID?: number;
    NAME?: string;
    DESCRIPTION?: string;
    ACTIVE?: number;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;

    ACCOUNT_REQUEST_ROLES?: any;
    PRIVILEGE_FEATURES?: any;
    TRANSITIONS?: any;
    USER_ROLES?: any;
    WORKFLOW_STATE_ROLES?: any;
}
